export default {"src":"/_next/static/media/rounded.07377e09.svg","height":149,"width":373,"blurWidth":0,"blurHeight":0};